import { configureStore } from '@reduxjs/toolkit';

import commonReducer from './reducer/commonReducer';
import controlTestScriptReducer from './reducer/controlTestScriptReducer';
import dataIngestionReducer from './reducer/data-ingestion-reducer';
import fieldMappingReducer from './reducer/field-mapping-reducer';
import horizonScanReducer from './reducer/horizonScanReducer';
import jobListReducer from './reducer/jobListReducer';
import mappingDetailsReducer from './reducer/mappingDetailsReducer';
import permissionsReducer from './reducer/permissionsReducer';
import promptBuilderReducer from './reducer/promptBuilderReducer';
import regulationInventoryReducer from './reducer/regulationInventoryReducer';
import settingsReducer from './reducer/settingsReducer';
import simulationReducer from './reducer/simulationReducer';
import taxonomyReducer from './reducer/taxonomyReducer';
import UserManagementListReducer from './reducer/UserManagementListReducer';
import userManagementReducer from './reducer/userManagementReducer';
import workflowReducer from './reducer/workflowReducer';

export const store = configureStore({
	reducer: {
		common: commonReducer,
		usersmanagement: userManagementReducer,
		jobsList: jobListReducer,
		settings: settingsReducer,
		dataingestion: dataIngestionReducer,
		fieldmapping: fieldMappingReducer,
		taxonomy: taxonomyReducer,
		mappingDetails: mappingDetailsReducer,
		usersListmgmt: UserManagementListReducer,
		regulationInventory: regulationInventoryReducer,
		controlTestScript: controlTestScriptReducer,
		permissionsmodule: permissionsReducer,
		workflowmodule: workflowReducer,
		simulationArena: simulationReducer,
		horizonScan: horizonScanReducer,
		promptBuilder: promptBuilderReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
